import { useState, useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import NewSignup from './NewSignup';
import { paymentsApi } from '../../../actions/paymentsApi';
import { CircularProgress, Box } from '@material-ui/core';
import CompleteSignup from './CompleteSignup';

const stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const stripePaymentTheme = {
    theme: 'none',
    rules: {
        '.Tab': {
            border: '1px solid rgb(23,43,77)',
            lineHeight: '1.4375rem',
        },
        '.Input': {
            border: '1px solid rgba(0,0,0, 0.23)',
            lineHeight: '1.4375rem',
            borderRadius: '4px',
            padding: '8.5px 14px'
        },
        '.Label': {
            color: 'rgb(0,0,0)',
            fontSize: '1rem',
            fontWeight: '700'
        }
    }
}

const SignupFlow = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [price, setPrice] = useState(null);
    const [promo, setPromo] = useState(null);
    const [setupIntentData, setSetupIntentData] = useState(null);

    /**
     * @type {import('@stripe/stripe-js').StripeElementsOptions}
     */
    const options = {
        clientSecret: setupIntentData?.client_secret,
        appearance: stripePaymentTheme,
    }

    const params = new URLSearchParams(location.search)

    useEffect(() => {
        createSetupIntent()
    }, [])

    useEffect(() => {
        if (location.pathname === '/yogarenew/signup/complete' && price) return

        const priceId = params.get('priceId')

        // If no subscription priceId is provided, redirect to the subscription page to select a plan
        if (!priceId) navigate('/yogarenew/subscriptions')

        paymentsApi.getPrice(priceId).then(price => {
            if (!price || price.error) navigate('/yogarenew/subscriptions')
            setPrice(price)
        })
    }, [navigate])

    useEffect(() => {
        let promoId = params.get('promoId')

        // Idk why this is here - it should be done server side and very much not hard coded.
        if (promoId === 'promo_1PQ96VKLx8bUE0lqhCDVSKvo') {
            promoId = 'promo_1PUAJaKLx8bUE0lqLcv8uBDV'
        }

        if (promoId) {
            paymentsApi.getPromo(promoId).then(promo => {
                if (!promo || promo.error) return
                setPromo(promo)
            })
        }
    }, [price])

    const createSetupIntent = async () => {
        const data = await paymentsApi.createSetupIntent();
        setSetupIntentData(data)
    }

    if (!price || !setupIntentData) return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: '5%' }}>
            <CircularProgress />
        </Box>
    )

    return (
        <Elements stripe={stripe} options={options}>
            <Routes location={location}>
                <Route
                    index
                    path="/"
                    element={
                        <NewSignup
                            price={price}
                            promo={promo}
                            setupIntent={setupIntentData}
                        />
                    }
                />
                <Route
                    path="/complete"
                    element={<CompleteSignup />}
                />
            </Routes>
        </Elements>
    )
}

export default SignupFlow;